/* eslint-env browser */
/*
 * Tab functionality for .nav-tabs
 *
 * https://getbootstrap.com/docs/3.4/javascript/#tabs
 */
require('../bootstrap/js/tab');
